import IntegrationPurchaseDownloadButton from './IntegrationPurchaseDownloadButton/IntegrationPurchaseDownloadButton'
import IntegrationPurchaseFilter from './IntegrationPurchaseFilter/IntegrationPurchaseFilter'
import IntegrationPurchasesZipDownloadButton from './IntegrationPurchasesZipDownloadButton/IntegrationPurchasesZipDownloadButton'
import OffsetByExcelButton from './OffsetByExcelButton/OffsetByExcelButton'

export const section = {
  IntegrationPurchaseDownloadButton,
  OffsetByExcelButton,
  IntegrationPurchaseFilter,
  IntegrationPurchasesZipDownloadButton
}
